import { Dialog } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import scrollbarStyles from "../scrollbarStyles";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-scrollPaper": {
    alignItems: "flex-start",
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
    },
  },
  "& .MuiPaper-root": {
    border: `0.65px solid ${theme.palette.grey.disabled}`,
    overflowX: "hidden",
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.md,
    [theme.breakpoints.down("sm")]: { width: "100vw" },
    [theme.breakpoints.up("md")]: { width: 632, minWidth: "632px" },
  },
  "&.narrow .MuiPaper-root": {
    [theme.breakpoints.down("sm")]: { width: "100vw" },
    [theme.breakpoints.up("md")]: { width: 480, minWidth: "480px" },
  },
  "& .MuiDialog-paperScrollPaper": {
    ...scrollbarStyles(theme),
  },
  "& .MuiDialog-paperScrollPaper::-webkit-scrollbar-track": {
    borderRadius: theme.spacing(0.5),
  },
}));

export default StyledDialog;
